import { DeleteOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import SortIcon from "../../../global/components/SortIcon";
import { hasRole } from "../../../global/hooks/getUserRole";

export const InvitationColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params
) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};
  const isSystemUser = [1, 2, 3].includes(loggedInUser?.role_value);

  const na = (val) =>
    val === null || val === undefined || val === "" ? "N/A" : val;

  const createSortableColumn = (title, dataIndex, sortKey, hidden, render) => ({
    title,
    dataIndex,
    key: dataIndex,
    hidden,
    render: render || ((val) => na(val)),
    sorter: () => {},
    sortIcon: () => (
      <SortIcon
        sortOrder={modParams.order}
        columnKey={sortKey}
        sortBy={modParams.sort_by}
      />
    ),
    onHeaderCell: () => ({
      onClick: () =>
        setParams(() => ({
          ...modParams,
          sort_by: sortKey,
          order: modParams.order === "desc" ? "asc" : "desc",
        })),
    }),
  });

  return [
    // No — only system roles (1,2,3)
    createSortableColumn("No", "InviteNo", "InviteNo", !isSystemUser),

    createSortableColumn("Email", "Email", "Email", false),

    createSortableColumn("Account Type", "AccountType", "AccountType", false),

    // OEM — only system roles (1,2,3), same as Device
    ...(hasRole(1, 2, 3)
      ? [createSortableColumn("OEM", "OemNo", "OemNo", false)]
      : []),

    // Dealer — system + oem roles (1-6), same as Device
    ...(hasRole(1, 2, 3, 4, 5, 6)
      ? [createSortableColumn("Dealer", "DealerNo", "DealerNo", false)]
      : []),

    // Customer — hidden for customer roles (9-12), same as Device
    ...(!hasRole(9, 10, 11, 12)
      ? [createSortableColumn("Customer", "CustomerNo", "CustomerNo", false)]
      : []),

    // Hover action column
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.InviteNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px]"
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
